<template>
    <div class="text-center mt-5 pt-5">
        <div class="display-1">
            404
        </div>

        <div class="h1">
            <i class="fa fa-search" /> Page introuvable...
        </div>
    </div>
</template>

<script>
    export default {
        name: "PageNotFound"
    }
</script>
